import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import Grid from '@material-ui/core/Grid';

export const AccountDetailsContainer = styled.div`
    display: block;
    width: 100%;
    height: calc(100% - 60px);
    position: relative;
    overflow-y: scroll;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;

    ${media.mobileDevice`
        height: 100vh;
    `}
`;

export const AccountDetailsBody = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    padding: 1rem;
    ${media.mobileDevice`
        padding:  1rem 1rem 0 1rem;
    `}
`;

export const AccountDetailsTabs = styled.div`
    display: flex;
    width: 100%;
    box-sizing: border-box;
    margin-top: 10px;
    ${media.mobileDevice`
       
    `}
`;

export const AccountDetailTabBody = styled.div`
    display: flex;
    flex-direction: column;
    width: 99%;
    margin: 0 auto;
`;
export const AccountDetailBodyContainer = styled.div`
    flex-grow: 1;
    overflow-y: scroll;
    margin-top: 5px;
    padding-right: 10px;
    box-sizing: border-box;
    &::-webkit-scrollbar {
        display: block;
        width: 5px;
    }

    &::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 10px;
        height: 12rem;
    }
    &::-webkit-scrollbar-thumb:hover {
        background: #555;
    }

    ${media.mobileDevice`
        &::-webkit-scrollbar {
            display: none;
        }
        padding-bottom: 175px;
        padding-right: 0;
    `}
`;

export const AccountDetailsGridContainer = styled(Grid)`
    width: 100%;
    min-height: 78px;
    background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
    opacity: 1;
`;

export const AccountDetailsGrid = styled(Grid)`
    text-align: left;
    letter-spacing: 0px;
    color: ##202124;
    opacity: 1;
    padding: 1rem 1rem 1rem 1rem;

    &.carrier-notes-container .p-inputtextarea {
        padding: 10px;
    }
    ${media.mediumDevice`
        `}
    ${media.mobileDevice`
    
      padding : ${
          ({ mbPadding, paddingBottom, paddingTop }) =>
              mbPadding
                  ? mbPadding
                  : paddingBottom
                  ? '1rem 1rem 0rem 1rem'
                  : paddingTop
                  ? '0rem 1rem 1rem 1rem'
                  : '1rem 1rem 1rem 1rem'
          //   ? '1rem 1rem 0rem 1rem'
      };
         `}
`;

export const AccountDetailsFont = styled.p`
    font-family: ${({ isRegular, isDemi, isItalic }) =>
        isRegular
            ? 'AvenirNextWorld Regular'
            : isDemi
            ? 'AvenirNextWorld Demi'
            : isItalic && 'AvenirNextWorld italic'};
    min-height: 20px;
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '10px'};
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : 'unset')};
    font-size: ${({ isDemi }) => (isDemi ? '14px' : '15px')};

    ${media.mediumDevice`
        margin-top: ${({ marginTop }) =>
            marginTop ? '18px !important' : 'unset'};
    `}
    ${media.mobileDevice`
        font-size: ${({ isDemi }) => (isDemi ? '14px' : '15px')};
        margin-top: ${({ mbMarginTop }) =>
            mbMarginTop ? mbMarginTop : '10px'};
        margin-bottom: ${({ mbMarginBottom }) =>
            mbMarginBottom ? mbMarginBottom : '10px'};
    `}
`;

export const AccountDetailsFontHead = styled.p`
    font-family: ${({ isRegular, isDemi, isItalic }) =>
        isRegular
            ? 'AvenirNextWorld Regular'
            : isDemi
            ? 'AvenirNextWorld Demi'
            : isItalic && 'AvenirNextWorld italic'};
    margin-bottom: 0px;
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : 'unset')};
    font-size: ${({ isDemi }) => (isDemi ? '14px' : '15px')};
    color: #140f4b;
    ${media.mediumDevice`
        margin-top: ${({ marginTop }) => (marginTop ? marginTop : 'unset')};
    `}
    ${media.mobileDevice`
        font-size: ${({ isDemi }) => (isDemi ? '14px' : '15px')};
        margin-top: ${({ mbMarginTop }) =>
            mbMarginTop ? mbMarginTop : '10px'};
    `}
`;

export const AccountDetailsFontMultiline = styled.p`
    font-family: 'AvenirNextWorld Regular';
    margin-bottom: 0px;
    line-height: 20px;
    margin-top: ${({ marginTop }) => (marginTop ? '0px' : 'unset')};
    font-size: 15px;
    color: #202124;
    word-break: break-all;
    ${media.mobileDevice`
        font-size: ${({ isDemi }) => (isDemi ? '14px' : '15px')};
        margin-top: ${({ mbMarginTop }) => (mbMarginTop ? mbMarginTop : '0px')};
    `};
`;

export const AccountDetailsTopTitle = styled.p`
    font-family: 'AvenirNextWorld Demi';
    font-size: 14px;
    margin-bottom: 0px;
    color: #202124;
    text-align: left;
    letter-spacing: 0px;
    color: #202124;
    opacity: 1;
    margin-top: 0;
    ${media.mobileDevice`
    margin-top:-9px;      `}
`;

export const SalesStructureHeader = styled.p`
    font-family: ${({ isRegular, isDemi, isItalic }) =>
        isRegular
            ? 'AvenirNextWorld Regular'
            : isDemi
            ? 'AvenirNextWorld Demi'
            : isItalic && 'AvenirNextWorld italic'};
    font-size: ${({ isDemi }) => (isDemi ? '14px' : '15px')};
    color: ${({ isRegular, isDemi }) =>
        isRegular ? '#140F4B' : isDemi && '#202124'};
    margin-bottom: 4px;
    margin-top: 0px;
    ${media.mobileDevice`
        font-size: ${({ isDemi }) => (isDemi ? '14px' : '15px')};
        margin-bottom: -10px;
    `}
`;

export const AccountDetailsTitle = styled.p`
    font-family: 'AvenirNextWorld Demi';
    font-size: 14px;
    margin-bottom: ${({ deskmarginBottom }) =>
        deskmarginBottom ? deskmarginBottom : '0px'};
    color: #202124;
    text-align: left;
    letter-spacing: 0px;
    color: #202124;
    opacity: 1;
    margin-top: ${({ deskmarginTop }) =>
        deskmarginTop ? deskmarginTop : '10px'};
    ${media.mobileDevice`
    margin-top: ${({ mbMarginTop }) => (mbMarginTop ? mbMarginTop : '10px')};
    margin-bottom: 0px;
`}
`;
export const AccountDetailsTitleAddress = styled.p`
    font-family: 'AvenirNextWorld Demi';
    font-size: 14px;
    margin-bottom: 5px;
    color: #202124;
    text-align: left;
    letter-spacing: 0px;
    color: #202124;
    opacity: 1;
    margin-top: 0px;
    ${media.mobileDevice`
    margin-top: 0px;
`}
`;

export const AccountDetailFirstCardFont = styled.span`
    font-family: ${({ isRegular, isDemi, isItalic }) =>
        isRegular
            ? 'AvenirNextWorld Regular'
            : isDemi
            ? 'AvenirNextWorld Demi'
            : isItalic && 'AvenirNextWorld italic'};
    font-size: ${({ isDemi }) => (isDemi ? '13px' : '13px')};
    color: #140f4b;
    margin-top: ${(props) => (props.marginTop ? props.marginTop : 'unset')};

    ${media.mobileDevice`
        font-size: ${({ isDemi }) => (isDemi ? '13px' : '13px')};
    `}
`;
export const DetailsTabs = styled.div`
    display: flex;
    width: 100%;
    box-sizing: border-box;
    // margin-bottom: 8px;
    margin-top: 4px;
    ${media.mediumDevice`
   margin-top:4px;
//    margin-bottom: 8px;
`}
    ${media.mobileDevice`
  //   margin-bottom: 10px;
    margin-top:10px;
`}
@media all and (width: 896px) and (height: 414px) and (orientation: landscape) {
        margin-bottom: 0px;
    }
`;

export const OrderDetailTabBodyContainer = styled.div`
    flex-grow: 1;
    overflow-y: scroll;
    margin-top: 0;
    // padding-right: 10px;
    padding-bottom: 30px;
    box-sizing: border-box;
    &::-webkit-scrollbar {
        display: block;
        width: 5px;
    }

    &::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 10px;
        height: 12rem;
    }
    &::-webkit-scrollbar-thumb:hover {
        background: #555;
    }

    ${media.mobileDevice`
        &::-webkit-scrollbar {
            display: none;
        }
        padding-right: 0;
        padding-bottom: 200px;
        margin-top: 0px;
    `}
`;

export const OrderDetailTabBody = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 15px;
    padding-left: 2px;
    padding-right: 5px;
    ${media.mobileDevice`
    margin-top: 15px;
    `};
`;
export const FavoriteIconMobileContainer = styled.span`
    display: none;
    ${media.smalDevice`
    display:none;
    `};
    ${media.mobileDevice`
    // margin-left: 235px;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 2px #00000029;
    border: 1px solid #ebebeb;
    border-radius: 6px;
    opacity: 1;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: ${({ marginRight }) => marginRight};
`};
`;

export const FavoriteIconDesktopContainer = styled.div`
    ${media.mobileDevice`
    display: none;
`};
`;

export const TextBold = styled.div`
    text-align: left;
    font-family: AvenirNextWorld Demi;
    font-size: 15px;
    color: ${(props) => props.color};
    margin-top: 0px;
    margin-bottom: 0px;
    letter-spacing: -0.12px;
    display: flex;
    align-self: center;
    margin: 0;
    padding: 0;
`;
export const RadioAlign = styled.div`
    display: flex;

    font-family: ${({ isRegular, isDemi, isItalic }) =>
        isRegular
            ? 'AvenirNextWorld Regular'
            : isDemi
            ? 'AvenirNextWorld Demi'
            : isItalic && 'AvenirNextWorld italic'};
    font-size: ${({ isDemi }) => (isDemi ? '14px' : '15px')};
    color: ${({ isRegular, isDemi }) =>
        isRegular ? '#140F4B' : isDemi && '#202124'};
    margin-bottom: 0px;
    padding-top: 10px;
    ${media.mobileDevice`
    font-size: ${({ isDemi }) => (isDemi ? '14px' : '15px')};
`}
`;

export const AccountDetailsPhoneFont = styled.p`
    font-family: 'AvenirNextWorld Regular';

    margin-bottom: 0px;
    margin-top: 7px;
    line-height: 1.4;
    min-height: 20px;
    font-size: 15px;
    color: #202124;
    ${media.mobileDevice`
    margin-top: 10px;
    font-family: 'AvenirNextWorld Demi';
    color:#1010EB;
    `}
`;
export const BottomNavigation = styled.div`
    display: flex;
    position: absolute;
    width: 100%;
    bottom: 0;
    margin: 0;
    right: 0;
    left: 0;
    padding: 8px 15px;
    background-color: #ffffff;
    justify-content: end;
    box-shadow: 0px -3px 6px #00000014;
    border-radius: 0;
    opacity: 1;

    ${media.mediumDevice`
        justify-content: flex-end;
    `}

    // ${media.ipadAir`
    //      position: fixed !important;
    // `}

    ${media.smalDevice`
        position: fixed !important;
    `}

    @media only screen and (max-width: 1112px) {
        padding: 8px 25px;
    }
    ${media.mobileDevice`
        justify-content: center;
        position: fixed !important;
        padding: 8px 0;
        background-color: #FFFFFF;
        z-index: 99900;
    `}
`;

export const SaaStyledDiv = styled.div`
    margin-bottom: 18px;
    :last-child {
        margin-bottom: 0;
    }
    ${media.mobileDevice`
        margin-bottom : 13px;
        :last-child {
            margin-bottom: 0;
        }
    `}
`;

export const StyledDiv = styled.div`
    display: flex;
`;
